import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { imgUrl, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useSettings } from "../context/SettingsContext";

export default function Register() {
  const { register } = useAuth();
  const { settings } = useSettings();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Ο λογαριασμός δημιουργήθηκε!");
      nav("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Σφάλμα εγγραφής");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full px-4 py-3 rounded-sm border border-[#E5E9E4] bg-white text-sm focus:border-[#1E3A2F] focus:ring-1 focus:ring-[#1E3A2F] outline-none";

  return (
    <div className="max-w-md mx-auto px-6 py-16">
      <div className="text-center mb-8">
        <img src={imgUrl(settings?.logo || "/logo.jpeg")} alt="logo" className="h-16 w-16 rounded-md object-cover mx-auto mb-4" />
        <h1 className="font-serif-display text-3xl text-[#1E3A2F]">Δημιουργία λογαριασμού</h1>
        <p className="text-[#536D61] mt-1 text-sm">Γρήγορες παραγγελίες & ιστορικό</p>
      </div>
      <form onSubmit={submit} className="space-y-4 bg-white border border-[#E5E9E4] rounded-sm p-6">
        <input data-testid="register-name" placeholder="Ονοματεπώνυμο" value={form.name} onChange={set("name")} className={inputCls} required />
        <input data-testid="register-email" type="email" placeholder="Email" value={form.email} onChange={set("email")} className={inputCls} required />
        <input data-testid="register-phone" placeholder="Τηλέφωνο (προαιρετικό)" value={form.phone} onChange={set("phone")} className={inputCls} />
        <input data-testid="register-password" type="password" placeholder="Κωδικός" value={form.password} onChange={set("password")} className={inputCls} required />
        <button data-testid="register-submit" disabled={loading} className="w-full bg-[#1E3A2F] text-white py-3 rounded-sm font-medium hover:bg-[#111C18] disabled:opacity-60">
          {loading ? "Δημιουργία..." : "Εγγραφή"}
        </button>
      </form>
      <p className="text-center text-sm text-[#536D61] mt-6">
        Έχετε ήδη λογαριασμό; <Link to="/login" className="text-[#1E3A2F] font-medium underline">Σύνδεση</Link>
      </p>
    </div>
  );
}
